import { GET_DASHBOARD_DATA, REFRESH_DASHBOARD } from 'actions/dashboard';

const initialState = {
  isLoading: false,
  dashboard: {},
  // Only a trigger, the dashboard refetches with its own filters when this changes
  refreshCount: 0,
};

const dashboardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_DASHBOARD_DATA.REQUEST: {
      return { ...state, isLoading: true };
    }

    case GET_DASHBOARD_DATA.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        dashboard: payload,
      };
    }

    case REFRESH_DASHBOARD: {
      return { ...state, refreshCount: state.refreshCount + 1 };
    }

    case GET_DASHBOARD_DATA.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default dashboardReducer;
